<template>
  <NavbarOne />
  <PageBanner
    pageTitle="تفاصيل المقال"
    subTitle="تعرف على أحدث الأخبار والمقالات والنصائح المتعلقة بخدمات IPTV والقنوات العربية والأفلام والمسلسلات."
    :pageBannerImage="pageBannerImg"
  />
  <BlogDetails />
  <SubscribeContent />
  <MainFooter class="bg-black" />
  <CopyRight />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useHead } from "@unhead/vue";
import NavbarOne from "@/components/Layouts/NavbarOne.vue";
import PageBanner from "@/components/Common/PageBanner.vue";
import BlogDetails from "@/components/BlogDetails/index.vue";
import SubscribeContent from "@/components/Common/SubscribeContent.vue";
import MainFooter from "@/components/Layouts/MainFooter.vue";
import CopyRight from "@/components/Layouts/CopyRight.vue";

export default defineComponent({
  name: "BlogDetailsPage",
  components: {
    NavbarOne,
    PageBanner,
    BlogDetails,
    SubscribeContent,
    MainFooter,
    CopyRight,
  },
  setup() {
    useHead({
      title: "تفاصيل المقال | أخبار ودليل IPTV والقنوات العربية",
      meta: [
        {
          name: "description",
          content:
            "اقرأ أحدث المقالات والنصائح المتعلقة بخدمات IPTV، القنوات العربية، الأفلام، المسلسلات، وأفضل طرق الاستفادة من خدمات البث بجودة HD و4K.",
        },
        {
          name: "keywords",
          content:
            "مقالات IPTV, أخبار IPTV, دليل IPTV, قنوات عربية, أفلام, مسلسلات, بث مباشر, HD, 4K",
        },
        {
          property: "og:title",
          content: "تفاصيل المقال | أخبار ودليل IPTV",
        },
        {
          property: "og:description",
          content:
            "اكتشف أحدث المقالات والنصائح حول خدمات IPTV والقنوات العربية والأفلام والمسلسلات.",
        },
        {
          property: "og:type",
          content: "article",
        },
        {
          name: "robots",
          content: "index, follow",
        },
      ],
      link: [
        {
          rel: "canonical",
          href: "https://karamtv4k.com/blog-details",
        },
      ],
    });

    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const pageBannerImg = require("@/assets/images/page-banner-9.jpg");

    return {
      pageBannerImg,
    };
  },
});
</script>